<template>

  <b-container>
    <b-row class="mt-5 align-center" v-if="order.length == 0">
      <b-col class="text-center align-self-center">
        <div class="empty-cart">
          <img :src="EmptyCartImage" alt="سبد خرید شما خالی است."/>
          <h4>سبد خرید شما خالی است!</h4>
        </div>
      </b-col>
    </b-row>
    <b-row class="d-flex flex-row justify-content-center mt-5 mb-5" v-if="order.length > 0">
      <b-col lg="8" md="7" sm="12" class="d-flex flex-column align-items-center">
        <b-row class="d-flex flex-row justify-content-center">
          <b-col lg="6" md="12" sm="12" class="d-flex flex-column align-items-center p-1" v-for="item in order"
                 :key="item.id">
            <b-card class="order-card h-100">
              <b-row class="d-flex flex-row justify-content-center">
                <b-col lg="6" md="6" sm="12" class="d-flex flex-column align-items-center p-1">
                  <img :src="item.product.thumbnail" :alt="item.product.name" class="rounded shadow w-100 h-100">
                </b-col>
                <b-col lg="6" md="6" sm="12" class="d-flex flex-column align-items-center p-1">
                  <b-card class="rounded shadow w-100 h-100 pt-3">
                    <div id="burst-12" v-if="item.product.offer>0">
                      <span class="discount">{{ getDiscountPercent(item.product.offer, item.product.price) }}%&MediumSpace;off</span>
                    </div>
                    <b-row>
                      <b-col class="d-flex flex-column align-items-center">
                        <span class="product-title">{{ item.product.name }}</span>
                        <span class="product-price">قیمت:
                          <span class="font-weight-bold">&MediumSpace;{{
                              getFormattedNumber(item.product.price - item.product.offer)
                            }}</span>
                          <span>&MediumSpace;تومان</span>
                        </span>
                      </b-col>
                    </b-row>
                    <b-row class="d-flex flex-row justify-content-center">
                      <a @click="removeItem(item.id, info.id)">
                        <b-icon class="p-trash" icon="trash" variant="danger"/>
                      </a>
                    </b-row>
                  </b-card>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>
      </b-col>
      <b-col lg="4" md="5" sm="12" class="d-flex flex-column align-items-center" v-if="order.length > 0">
        <b-card class="info-card">
          <b-row>
            <b-col>
              <b-row>
                <b-col class="d-flex flex-column align-items-start"><span class="info">تعداد:</span></b-col>
                <b-col class="d-flex flex-column align-items-end"><span class="info font-weight-bold">{{ order.length }} عدد</span>
                </b-col>
              </b-row>
              <b-row>
                <b-col class="d-flex flex-column align-items-start"><span class="info">مجموع قیمت:</span></b-col>
                <b-col class="d-flex flex-column align-items-end">
                  <span class="info font-weight-bold">{{ getFormattedNumber(parseInt(info.total_amount)) }} تومان</span>
                </b-col>
              </b-row>
              <b-row>
                <b-col class="d-flex flex-column align-items-start"><span class="info text-danger">مجموع تخفیف:</span>
                </b-col>
                <b-col class="d-flex flex-column align-items-end">
                  <span class="info text-danger font-weight-bold">{{ getFormattedNumber(parseInt(info.offer_amount)) }} تومان</span>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <b-row class="d-flex flex-row justify-content-center">
            <hr class="info-hr w-75">
          </b-row>
          <b-row class="d-flex flex-row justify-content-center">
            <b-col class="d-flex flex-column align-items-center p-0"><span class="info text-success">قابل پرداخت:</span>
            </b-col>
            <b-col class="d-flex flex-column align-items-center p-0">
              <span class="info text-success font-weight-bold">{{ getFormattedNumber(parseInt(info.paying_amount)) }} تومان</span>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="d-flex flex-column align-items-center">
              <b-button class="m-2" variant="danger" @click="continueOrder(info)">ادامه و پرداخت</b-button>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import {mapGetters} from "vuex";
import {formatNumber} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import {toast} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Notification"

export default {
  name: "UnPaidOrder1",
  props: {
    EmptyCartImage: {
      type: String,
      default: require('../../../assets/empty-cart.svg')
    }
  },
  data() {
    return {
      rawPrice: 0,
      totalDiscount: 0,
      payable: 0
    }
  },
  computed: {
    ...mapGetters({
      order: "ShoppingCart/getUserOrderUnpaidItems",
      info: "ShoppingCart/getSidebarBasketData"
    })
  },
  methods: {
    getFormattedNumber(num) {
      return formatNumber(num)
    },
    getDiscountPercent(off, price) {
      if (off < 100) {
        return off
      } else {
        return Math.round((off / price) * 100)
      }
    },
    removeItem(productId, basketId) {
      let form = {order_product_id: productId, basket_id: basketId}
      this.$store.dispatch("ShoppingCart/removeItem", form).then(res => {
            toast("", "محصول از سبد خرید شما حذف شد")
          }
      )
    },
    continueOrder(order_) {
      this.$store.dispatch("Transaction/createTransaction", order_.id)
    },
    async getUnAuthBasketItems() {
      if (localStorage.getItem('products') !== null) {

        let productsJson = JSON.parse(localStorage.getItem('products'))
        let products = []
        Object.keys(productsJson).forEach(function (key) {
          let quantity = productsJson[key]['quantity']
          for (let i = 0; i < quantity; i++) {
            products.push(key)
          }
        })
        await this.$store.dispatch("ShoppingCart/addItem", {product_id: products})
        localStorage.removeItem('products')
      }
    }
  },
  mounted() {
    this.getUnAuthBasketItems();
    this.$store.dispatch("ShoppingCart/userOrderUnpaid")
  }
}
</script>

<style scoped>
.order-card {
  background-color: #ECECEC;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 20%);
}

.info-card {
  background-color: #ECECEC;
  width: 100%;
}

.product-title {
  font-size: 14px;
  font-weight: bold;
}

.product-price {
  font-size: 13px;
}

.p-trash {
  font-size: 14px;
}

.empty-cart {
  min-height: 18rem;
}

#burst-12 {
  background: var(--primary);
  width: 40px;
  height: 40px;
  position: absolute;
  top: 0;
  left: 0px;
  z-index: 5;
  text-align: center;
}

#burst-12:before,
#burst-12:after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  height: 40px;
  width: 40px;
  background: var(--primary);
  z-index: 2;
}

#burst-12:before {
  transform: rotate(30deg);
  z-index: 3;
}

#burst-12:after {
  transform: rotate(60deg);
  z-index: 4;
}

.discount {
  position: absolute;
  top: 2px;
  left: 2px;
  z-index: 7;
  font-size: 12px;
  font-weight: bold;
  color: var(--secondary) !important;
}

.info {
  font-size: 13px;
  padding: 10px 5px 0;
}

.info-hr {
  border: 0;
  border-bottom: 1px dashed #ccc;
  background: black;
}
</style>